import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=3a89d5c8"
import script from "./ProjectSelect.ts?vue&type=script&lang=ts&external"
export * from "./ProjectSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports